import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// components
import EditorialModuleArticles from 'dibs-editorial-module/exports/EditorialModuleArticles';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

// styles
import styles from './PdpSharedEditorialArticles.scss';

// types
import { type PdpSharedEditorialArticles_refactor_item$key as Item } from './__generated__/PdpSharedEditorialArticles_refactor_item.graphql';

const NUM_EDITORIAL_ARTICLES = 2;

const itemQuery = graphql`
    fragment PdpSharedEditorialArticles_refactor_item on Item {
        storyTellingModule(shortTitles: true) {
            tabs {
                supplementaryEditorial {
                    articles {
                        ...EditorialModuleArticles_articles
                    }
                }
            }
        }
    }
`;

export const PdpSharedEditorialArticles: FC<{
    item: Item;
    showDivider?: boolean;
}> = ({ item: itemRef, showDivider }) => {
    const item = useFragment(itemQuery, itemRef);
    const articles =
        item?.storyTellingModule?.tabs?.[0]?.supplementaryEditorial?.articles?.slice(
            0,
            NUM_EDITORIAL_ARTICLES
        ) || [];

    if (!articles.length) {
        return null;
    }

    return (
        <>
            {showDivider && <div className={styles.sectionDivider} />}
            <div className={styles.container}>
                <EditorialModuleArticles
                    articles={articles}
                    useWhiteBg
                    launchOrigin={PAGE_TYPE.PDP}
                />
            </div>
        </>
    );
};
